import React from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import PrivacyUkr from "../../widgets/PrivacyPolicy/PrivacyUkr";
import "./Footer.scss";

const Footer = () => {
  // const openQuestionModal = () => {
  //   console.log("Open Question Modal");
  // };
  const navigate = useNavigate();
  const smile = "\u{1F604}";

  const proposals = {
    href: "https://t.me/+LV2R7SclKzY0ODcy",
    target: "_blank"
  };
  return (
    <footer className="footer">
      <p>
        ARYN Lyrics є новим проектом, тому поспішайте наповнювати його
        збірниками та піснями! Бажаємо приємного користування {smile}
      </p>
      <hr />
      <div className="footer-authors">
        <div>
          Приєднуйтесь до нашої телеграм групи, де ми оголошуємо новини і де
          можна вносити пропозиції та ставити запитання. Тисніть{" "}
          <a
            href={proposals.href}
            target={proposals.target}
            rel="noreferrer"
            className="footer_link"
          >
            СЮДИ
          </a>
          <p className="scan">
            або скануйте
            <img className="qrcode" src="/images/telegram_chat.png" alt="" />
          </p>
          <p>
            {" "}
            Можете також звернутись до нас за електронною адресою{" "}
            <span className="footer-email">arynlyrics@gmail.com</span>
          </p>
          <div className="pp" onClick={() => navigate("/privacypolicyukr")}>
            Політика конфіденційності сайту
          </div>
        </div>
        <div>
          Автори та розробники проекту{" "}
          {/* <a href="/" className="footer_link">
            Aryn-lyrics
            </a>{" "} */}
          команда <span className="footer-email">ARYN-devs</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
